export default __webpack_public_path__ + "media/zurb/img/playground/piggy-bank-img-b78ffea7b430b539962cb0ed8771ec2e.png";